/** API messages that mean the user must request HR/Admin access for pending/missed updates. */
const MONTHLY_ACCESS_BLOCKED_MESSAGE_MATCHERS = [
  "pending daily work updates from the previous month",
  "previous month editing is locked",
  "request approval from hr/admin",
  "request access from hr/admin",
  "missed current-month updates",
  "locked missed updates",
];

export function getErrorMessage(error) {
  if (!error) return "";
  if (typeof error === "string") return error;
  const nested = error?.error;
  if (typeof nested === "string") return nested;
  return (
    error?.message ||
    nested?.message ||
    error?.response?.data?.error?.message ||
    ""
  );
}

export function isMonthlyAccessBlockedError(error) {
  const message = String(getErrorMessage(error) || "").toLowerCase();
  if (!message) return false;
  return MONTHLY_ACCESS_BLOCKED_MESSAGE_MATCHERS.some((part) =>
    message.includes(part)
  );
}
